import { AxiosResponse } from 'axios'
import { toEnglish } from '../../../helpers/props'
import { HouseCardItemProps } from '../reducer/homeReducer'
import { MainAction } from './models'
import {
  FETCH_AROUND,
  FETCH_BANNERS_PICTURE,
  FETCH_BEST_RANKS,
  FETCH_HERO,
  FETCH_JONOOB,
  FETCH_LATEST_BLOG,
  FETCH_RESERVED_HOUSES,
  FETCH_SELECTED_CATEGORIES,
  FETCH_SHOMAL,
  FETCH_STATISTICS,
  FETCH_THRAN_CITY,
  FETCH_BOOMGARDI,
} from './types'

export const fetchBannersPicture: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_BANNERS_PICTURE,
        data: [],
        loading: true,
      })
      const res = await api.get('/home/banners')
      dispatch({
        type: FETCH_BANNERS_PICTURE,
        data: res?.data,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_BANNERS_PICTURE,
        data: [],
        loading: false,
      })
      // Handle Err
    }
  }

export const fetchHeroImageL: MainAction<any> =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      const res = await api.get('/hero-images')
      dispatch({
        type: FETCH_HERO,
        payload: res?.data?.data,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_HERO,
        payload: {
          mobile: null,
          dekstop: null,
        },
      })
      // Handle Err
    }
  }

export const fetchByCity: MainAction<[string?, any?]> =
  (cityName: string = 'تهران', customParams: any = null) =>
  async (dispatch, getState, { Api, ctx }) => {
    if (!customParams) {
      customParams = { near_cities: [cityName] }
    }

    const api = new Api({ dispatch, getState, ctx })
    const {
      aroundHouses: { list },
    } = getState()

    try {
      dispatch({
        type: FETCH_AROUND,
        list,
        loading: true,
      })
      const res: AxiosResponse<{ data: { records: HouseCardItemProps[] } }> =
        await api.get('/house/search', {
          perpage: 10,
          ...customParams,
        })
      dispatch({
        type: FETCH_AROUND,
        list: res?.data?.data?.records,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_AROUND,
        list,
        loading: false,
      })
      // Handle Err
    }
  }
export const fetchByShomal: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      dispatch({
        type: FETCH_SHOMAL,
        list: getState().shomalHouses.list,
        loading: true,
      })
      const res: AxiosResponse<{ data: { records: HouseCardItemProps[] } }> =
        await api.get('/house/search', {
          perpage: 10,
          province: ['گیلان', 'مازندران', 'گلستان'],
          page: 1,
        })
      dispatch({
        type: FETCH_SHOMAL,
        list: res?.data?.data?.records,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      // Handle Err
      dispatch({
        type: FETCH_SHOMAL,
        list: getState().shomalHouses.list,
        loading: false,
      })
    }
  }
export const fetchByJonoob: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      dispatch({
        type: FETCH_JONOOB,
        list: getState().jonoobHouses.list,
        loading: true,
      })
      const res: AxiosResponse<{ data: { records: HouseCardItemProps[] } }> =
        await api.get('/house/search', {
          perpage: 10,
          city: ['چابهار', 'کیش', 'هرمز', 'قشم'],
          page: 1,
        })

      dispatch({
        type: FETCH_JONOOB,
        list: res?.data?.data?.records,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      // Handle Err
      dispatch({
        type: FETCH_JONOOB,
        list: getState().jonoobHouses.list,
        loading: false,
      })
    }
  }
export const fetchTehran: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    const type = FETCH_THRAN_CITY
    const list = getState().tehranHouses.list
    try {
      dispatch({
        type,
        list,
        loading: true,
      })
      const res: AxiosResponse<{ data: { records: HouseCardItemProps[] } }> =
        await api.get('/house/search', {
          perpage: 10,
          city: ['تهران'],
          page: 1,
        })
      dispatch({
        type,
        list: res?.data?.data?.records,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type,
        list,
        loading: false,
      })
      // Handle Err
    }
  }
export const fetchBoomgardi: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    const type = FETCH_BOOMGARDI
    const list = getState().boomgardiHouses.list
    try {
      dispatch({
        type,
        list,
        loading: true,
      })
      const res: AxiosResponse<{ data: { records: HouseCardItemProps[] } }> =
        await api.get('/house/search', {
          perpage: 10,
          'category[]': 'boomgardi',
          page: 1,
        })
      dispatch({
        type,
        list: res?.data?.data?.records,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type,
        list,
        loading: false,
      })
      // Handle Err
    }
  }
// Statistics action:
export const fetchStatistics: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      dispatch({
        type: FETCH_STATISTICS,
        data: {},
        loading: true,
      })
      const res = await api.get('/house/statistics')

      dispatch({
        type: FETCH_STATISTICS,
        data: res.data,
        loading: false,
      })
    } catch (err) {
      dispatch({
        loading: false,
        type: FETCH_STATISTICS,
        data: {},
      })
    }
  }

// latest blog
export const fetchLatestBlog: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_LATEST_BLOG,
        list: [],
        loading: true,
      })
      const res = await api.get('/blog/recent', {
        perpage: 6,
      })

      dispatch({
        type: FETCH_LATEST_BLOG,
        list: res?.data,
        loading: true,
      })
    } catch (err) {
      dispatch({
        type: FETCH_LATEST_BLOG,
        list: [],
        loading: false,
      })

      // Handle Err
    }
  }

// Ranks:
export const fetchBestRanks: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_BEST_RANKS,
        list: [],
        loading: true,
      })
      const res = await api.get('/house/search?is_descending[recent_rank]=1', {
        perpage: 6,
      })
      dispatch({
        type: FETCH_BEST_RANKS,
        list: res?.data.data.records,
        loading: true,
      })
    } catch (err) {
      dispatch({
        type: FETCH_BEST_RANKS,
        list: [],
        loading: false,
      })

      // Handle Err
    }
  }

export const fetchSelectedCategories: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    dispatch({
      type: FETCH_SELECTED_CATEGORIES,
      list: [],
      loading: true,
    })

    try {
      const res = await api.get('/house/selected-categories')

      dispatch({
        type: FETCH_SELECTED_CATEGORIES,
        list: res?.data?.data,
        loading: false,
      })
    } catch (err) {
      // Handle Err
      dispatch({
        type: FETCH_SELECTED_CATEGORIES,
        list: [],
        loading: false,
      })
    }
  }

export interface RegionResult {
  id: string
  name: string
  type: string
  type_label: string
  province: {
    id: string
    name: string
  }
  houses_count: number
}

export interface NearCityResult {
  id: string
  name: string
  type: string
  type_label: string
  province: {
    id: string
    name: string
  }
  houses_count: number
}

export interface HomeItemResult {
  cover_photo: string
  title: string
  id: number
  is_instant: boolean
  city: string
  province: string
  type: string
  rooms_count: number
}

export interface SearchResult {
  regions: RegionResult[]
  houses: HomeItemResult[]
  near_regions: NearCityResult[]
}

export const searchSuggestion: MainAction<
  [string, (resultData: SearchResult) => void]
> =
  (phrase: string, callback: (resultData: SearchResult) => void) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      const res: AxiosResponse<SearchResult> = await api.get(
        '/house/suggestions',
        { phrase: toEnglish(phrase) },
      )
      callback(res?.data)
    } catch (err) {
      // Handle Err
    }
  }
